import { decodeNumber } from "./decodeNumber";

export function decodeString(data: Uint8Array, offset = 0): [string, number] {
  const [length, lengthBytes] = decodeNumber(data, offset + 1);
  const start = offset + 1 + lengthBytes;
  const end = start + length;

  const text = new TextDecoder().decode(data.subarray(start, end));
  return [text, end - offset];
}
